import * as Regs from './regs'
import emoji from 'emoji-regex'
import whiteHost from 'Src/const/whiteHost.js'
import Urls from 'Src/util/url'
import where from 'lodash.where'
import safetyGet from 'lodash.get'

const emojiRegex = emoji()

// let tool = {}
export const showHint = (text, type, timeout = 3000) => {
  (new Vue()).$message(text, type, timeout)
}

export const jsonToQuery = (obj, prefix) => {
  return (typeof (prefix) === 'undefined' ? '?' : prefix) + Object.keys(obj)
    .filter(item => (typeof (obj[item]) !== 'undefined') && (obj[item] !== null))
    .map(item => {
      return [item, encodeURIComponent(obj[item])].join('=')
    }).join('&')
}

export const queryToJson = (url) => {
  url = url || window.location.href

  let reg = /(?:\?(.*?=[^#]*))+/g
  let regObj = {}
  let paramsArray = []

  while (regObj) {
    regObj = reg.exec(url)
    if (regObj) {
      paramsArray.push(regObj[1])
    }
  }
  let params = paramsArray.join('&')

  let obj = {}
  params.split('&').forEach(item => {
    let row = item.split('=')
    if (row.length === 2) {
      obj[row[0]] = decodeURIComponent(row[1])
    }
  })
  return obj
}

export const getValFromArray = (arr, options, key) => {
  let result = arr.filter(item => {
    return Object.keys(options).every(option => {
      return item[option] === options[option]
    })
  })
  if (result.length) {
    return result[0][key]
  }
  return null
}

export const getStringLen = function (str) {
  if (str == null) return 0
  if (typeof str !== 'string') {
    str += ''
  }
  return str.replace(/[\u4e00-\u9fa5]/g, '01').length
}

// 截取指定字符串
export const getStr = function (name, maxLen) {
  let nameArr = name.split('')
  let charLen = 0
  return nameArr.filter((c) => {
    charLen = charLen + ((/[\u4e00-\u9fa5]/g).test(c) ? 2 : 1)
    return charLen <= maxLen
  }).join('')
}

export const updateQueryNoRefresh = (newQueryObj, state) => {
  let queryObj = queryToJson()
  Object.keys(newQueryObj).forEach(item => {
    queryObj[item] = newQueryObj[item]
  })
  window.history.pushState(state || {}, 0, window.location.pathname + jsonToQuery(queryObj))
}

export const updateQueryRefresh = (newQueryObj) => {
  let queryObj = queryToJson()
  Object.keys(newQueryObj).forEach(item => {
    queryObj[item] = newQueryObj[item]
  })
  window.location.href = window.location.pathname + jsonToQuery(queryObj)
}

export const replaceQueryNoRefresh = (newQueryObj, state) => {
  let params = jsonToQuery(newQueryObj)
  let newUrl = window.location.pathname + (params ? '?' + params : '')
  window.history.pushState(state || {}, 0, newUrl)
}

export const repeat = (str, len, fix, after) => {
  str = (str || '').toString()
  fix = (fix || '0').toString()

  while (str.length < len) {
    if (after) {
      str += fix
    } else {
      str = fix + str
    }
  }
  return str.slice(0, len)
}

export const secondToMinute = (seconds) => {
  seconds = parseInt(seconds)
  let minute = repeat(Math.floor(seconds / 60), 2)
  let second = repeat(seconds % 60, 2)
  return [minute, second].join(':')
}

export const parseSecondToDate = (seconds) => {
  let date = new Date(parseInt(seconds) * 1000)
  return dateFormat(date)
}

export const dateFormat = (date, format = 'yyyy-MM-dd') => {
  function formatFunc (time, fmt) {
    var o = {
      'M+': time.getMonth() + 1, // 月份
      'd+': time.getDate(), // 日
      'h+': time.getHours(), // 小时
      'm+': time.getMinutes(), // 分
      's+': time.getSeconds(), // 秒
      'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
      S: time.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1)
          ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }

  if (type(date) !== 'Date') {
    date = new Date(+date)
  }
  return formatFunc(date, format)
}

export const getTotalDaysOfTimeRange = (startTime, endTime) => {
  let stTime = dayjs(dayjs(startTime).format('YYYY-MM-DD'))
  let etTime = dayjs(dayjs(endTime).format('YYYY-MM-DD'))
  let diffDay = etTime.diff(stTime, 'day')
  return diffDay + 1
}

/**
 * 将 UNIX timestamp 时间标签转换成 formatter 格式
 * @param {Number} 时间标签 e.g. 1463368789044
 * @param {String} 格式 e.g. 'yyyy-mm-dd hh:MM'
 * @returns {String} e.g. '2016-05-16 18:17'
 */
export const timestampConverter = (timestamp, formatter) => {
  var a = new Date(timestamp * 1000)
  var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
  var year = '' + a.getFullYear()
  var month = months[a.getMonth()]
  var day = '0' + a.getDate()
  var hour = '0' + a.getHours()
  var minute = '0' + a.getMinutes()
  var second = '0' + a.getSeconds()

  return formatter.replace('yyyy', year)
    .replace('yy', year.substr(-2))
    .replace('mm', month)
    .replace('dd', day.substr(-2))
    .replace('hh', hour.substr(-2))
    .replace('MM', minute.substr(-2))
    .replace('ss', second.substr(-2))
}

/**
 * 将JSON数据解析为JS对象，可捕获异常
 * @param {string} json JSON形式的字符串，可以不符合json规则或undefined
 * @returns {object} obj 经JSON.parse()后的结果，若无法解析，则为undefined
 */
export const catchableParse = function (json) {
  try {
    return JSON.parse(json)
  } catch (e) {
    return json
  }
}

/**
 * 获取当天零点的时间戳
 */
export const getTodayTimestamp = () => {
  const now = new Date()
  const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' 00:00:00'
  return new Date(today).getTime()
}

/**
 * 将大数添加分隔符
 */
export const formatBigNum = (num) => {
  if (isNaN(num) || (num === '')) {
    return num
  }
  const [intPart, decimalPart] = String(num).split('.')
  let count = 0
  const intLen = intPart.length
  const temp = intPart.split('').reverse()
  temp.map((_, index, arr) => {
    (index % 3 === 2) && (index < intLen - 1) && arr.splice(index + ++count, 0, ',')
  })
  return [temp.reverse().join(''), decimalPart].join(decimalPart ? '.' : '')
}

export const type = (obj) => {
  return Object.prototype.toString.call(obj).match(/\[object (.*?)\]/)[1]
}

export const getKeyByValue = (obj, value) => {
  return Object.keys(obj).filter(key => {
    return obj[key].value === value
  })[0]
}

export const getObjectKeyByValue = (obj, value) => {
  return Object.keys(obj).find(key => obj[key] === value)
}

export const log = (...args) => {
  console.log(args)
}
export const error = (...args) => {
  console.error(args)
}
/**
 * @comment 优化显示, 保留用户输入内容, 如广告组名称
 * @param str string
 */
export const secHtmlNew = (str) => {
  str = (str || '').toString()
  let character = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    '\'': '&#039;'
  }
  return str.replace(/[<>&"']/g, function (c) {
    return character[c]
  })
}
/**
 * @param htmlStr string
 * @param whiteTags optional String 'a div p span'
 * @param spliter optional String ' '
 */
export const secHtml = function (htmlStr, whiteTags, spliter) {
  let rootTagName = Math.random().toString(36).replace('0.', 'byted')
  let dom = (new window.DOMParser())
    .parseFromString('<' + rootTagName + '>' + (htmlStr || '') + '</' + rootTagName + '>', 'text/html')
    .getElementsByTagName(rootTagName)[0]
  let attrFilterRules = [{
    name: 'rull-style',
    attrs: ['style'],
    reg: /expression\(.*\)/i,
    replaceValue: ''

  },
  {
    name: 'rull-href',
    attrs: ['src', 'href'],
    reg: /^(javascript|vbscript|jscript|ecmascript):|data:text\/html/i,
    replaceValue: ''

  },
  {
    name: 'rule-onevent',
    attrs: (function () {
      let tags = []
      for (let attr in dom) {
        if (attr.indexOf('on') === 0) {
          tags.push(attr)
        }
      }
      return tags
    })(),
    replaceValue: ''

  }
  ]
  if (spliter === void 0) {
    spliter = /\s+/g
  }
  if (whiteTags === void 0) {
    whiteTags = ['A', 'ADDRESS', 'B', 'BIG', 'BLOCKQUOTE', 'BR', 'CAPTION', 'CENTER', 'CITE', 'CODE', 'DD',
      'DEL', 'DIV', 'DL', 'DT', 'EM', 'FONT', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'HR', 'I', 'IMG', 'KBD',
      'LI', 'NOBR', 'OL', 'P', 'PRE', 'S', 'SECTION', 'SMALL', 'SPAN', 'STRIKE', 'STRONG', 'STRONG', 'SUB',
      'SUP', 'SVG', 'TABLE', 'TBODY', 'TD', 'TFOOT', 'TH', 'THEAD', 'TR', 'U', 'UL', 'let'
    ]
  } else {
    whiteTags = whiteTags.split(spliter).map(function (tag) {
      return tag.toUpperCase()
    })
  }
  let toArray = function (obj) {
    return [].slice.apply(obj)
  }
  toArray(dom.querySelectorAll('*')).forEach(function (node, i) {
    if (whiteTags.indexOf(node.tagName) > -1) {
      toArray(node.attributes).forEach(function (attr) {
        attrFilterRules.some(function (rule) {
          let tagMatched = rule.attrs.indexOf(attr.nodeName) > -1
          if (tagMatched) {
            if ((rule.reg && rule.reg.test(attr.nodeValue.replace(/\s/g, ''))) || !rule.reg) {
              attr.nodeValue = rule.replaceValue
            }
          }
          return tagMatched
        })
      })
    } else {
      node.outerHTML = en(node.outerHTML)
    }
  })
  return dom.innerHTML
}

/**
 *
 * @param str - 编码html
 */
export const en = function (str) {
  str = (str || '').toString()
  var character = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    '\'': '&#039;'
  }
  return (function () {
    return str.replace(/[<>&"']/g, function (c) {
      return character[c]
    })
  }())
}

/**
 *节流函数 按最早时间触发 响应最早动作 保证指定间隔执行一次
 * @param action 回调动作
 * @param interval 间隔时间
 * @returns {function(...[*]=)}
 */
export const throttle = (action, interval = 100) => {
  let timer = 0
  return (...args) => {
    if (!timer) {
      timer = setTimeout(() => {
        action && action.apply(null, args)
        timer = 0
      }, interval)
    }
  }
}

/**
 * 节流函数 按最新时间触发 响应最新动作 连续动作只执行一次
 * @param action 回调动作
 * @param interval 间隔时间
 * @returns {function(...[*]=)}
 */
export const debounce = (action, interval = 100) => {
  let timer = 0
  return (...args) => {
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      action && action.apply(null, args)
    }, interval)
  }
}

export const sessionStore = {
  getObj (key) {
    let data = {}
    try {
      data = JSON.parse(window.sessionStorage.getItem(key)) || {}
    } catch (e) {

    }
    return data
  },
  removeObj (key) {
    try {
      window.sessionStorage.removeItem(key)
    } catch (e) {
      error(e)
    }
  },
  setObj (key, data) {
    let result = true
    try {
      window.sessionStorage.setItem(key, JSON.stringify(data))
    } catch (e) {
      result = false
    }
    return result
  }
}

export const randomChar = (len = 6, str = '') => {
  while (str.length < len) {
    str += String.fromCharCode((Math.random() > 0.5 ? 97 : 65) + Math.round(Math.random() * 25))
  }
  return str
}
// ??//
export const trys = (fn, ...args) => {
  try {
    fn && fn.apply(null, args)
  } catch (e) {
    error(e)
  }
}

export const StrLen = (str) => {
  return (str || '').replace(new RegExp(Regs.strWithZhCn, 'g'), '00').length
}

/**
 * @description: 字段校验
 * @param {type} data 需要校验的字段
 * @param {type} rules 校验规则
 * @param {type} config modules.js中的config
 * @param {type} modules
 * @return: 校验结果
 */
export const validField = (data, rules, config, modules) => {
  const result = {
    ok: true,
    msg: ''
  }
  rules.some(rule => {
    if (!rule.ok(data, config, modules)) {
      result.ok = false
      result.msg = typeof rule.msg === 'function'
        ? rule.msg(data, config, modules)
        : rule.msg
      return true
    }
  })

  return result
}

export const clearObj = (obj, whiteKeys = []) => {
  Object.keys(obj).forEach(key => {
    if (whiteKeys && whiteKeys.indexOf(key) > -1) {
      return
    }
    delete obj[key]
  })
  return obj
}

export const clearArr = (arr) => {
  while (arr.length) {
    arr.splice(0, 1)
  }
  return arr
}

export const isSupported = (() => {
  let funs = []
  try {
    funs = JSON.parse(window.GLOBAL_VAR.funcsOpened)
  } catch (e) {}
  return (value) => {
    return funs.includes(parseInt(value))
  }
})()

export const isBpSupported = (() => {
  let funcs = []
  try {
    funcs = JSON.parse(window.GLOBAL_VAR.funcsOpenedUser)
  } catch (e) {}
  return (value) => {
    return funcs.includes(parseInt(value))
  }
})()

export const parseUrl = (url) => {
  url = url || window.location.href
  if (window.URL) {
    try {
      return new window.URL(url)
    } catch (e) {}
  }

  let a = document.createElement('a')
  a.href = url
  return {
    protocol: a.protocol,
    host: a.host,
    hostname: a.hostname,
    href: a.href,
    origin: a.origin,
    port: a.port || '80',
    search: a.search,
    searchParams: queryToJson(a.href),
    hash: a.hash,
    pathname: a.pathname,
    password: a.password,
    username: a.username
  }
}

export const randArr = (arr) => {
  return arr.map(value => {
    return {
      value: value,
      factor: Math.random()
    }
  })
    .sort((a, b) => a.factor - b.factor)
    .map(item => item.value)
}

/**
 * 数组全排列
 * @param list 数组
 * @returns [[]]
 */
export const permutation = (list) => {
  return list.length ? list.reduce((acc, x) => acc.concat(permutation(list.filter(e => e !== x)).map(a => [x].concat(a))), []) : [
    []
  ]
}

/**
 * 保留n位小数，四舍五入（toFixed四舍五入有陷阱）
 * @param number
 * @param fractionDigits
 * @returns string
 */
export const rounding = (number, fractionDigits) => {
  return (!isNaN(number) && !isNaN(fractionDigits)) ? (Math.round(number * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits)).toFixed(fractionDigits) : ''
}

/**
 * 获得连续的子数组
 * 用法见 weektime.vue
 * @param arr: Array
 * @returns rangeArr: Array
 */
export const getContinuousChildArr = (arr) => {
  if (!(arr instanceof Array)) {
    console.error('ERROR: getContinuousChildArr() Input is not Array.')
    return []
  }

  let rangeArr = []

  let rangeStartIndex = 0
  let rangeEndIndex = 0
  arr.forEach((item, curIndex, thisArr) => {
    const nextIndex = curIndex + 1
    const nextItem = thisArr[nextIndex]

    const itemIsContinuous = (nextItem === item + 1)

    if (!itemIsContinuous) {
      if (rangeStartIndex !== rangeEndIndex) {
        rangeArr.push([
          thisArr[rangeStartIndex],
          thisArr[rangeEndIndex]
        ])
      } else {
        rangeArr.push([item])
      }

      rangeStartIndex = nextIndex
      rangeEndIndex = nextIndex
    } else {
      rangeEndIndex = nextIndex
    }
  })

  return rangeArr
}

/**
 * 将时间索引转化为字符串
 * 详情见 weektime.vue
 * @param id: String,
 * @param type: String,
 * @returns clock: String
 */
export const getClockString = (id, type) => {
  if (!Number.isInteger(id)) {
    console.error('ERROR: getClockString() Input id is not integer.')
    return ''
  }
  if (type !== 'start' && type !== 'end') {
    console.error('ERROR: getClockString() Input type is not legal.')
    return ''
  }

  let clock = ''
  let h = Math.floor(id / 2)
  let min = id % 2
  if (type === 'end' && min === 1) {
    h += 1
  }

  if (h <= 9) {
    clock += '0' + h
  } else {
    clock += h
  }
  if (type === 'start') {
    if (min === 1) {
      clock += ':30'
    } else {
      clock += ':00'
    }
  } else {
    if (min === 0) {
      clock += ':30'
    } else {
      clock += ':00'
    }
  }
  return clock
}
/**
 * 最小8位、大小写、特殊字符、数字
 * @param val
 * @returns {boolean}
 */
export const checkPwd = (val = '') => {
  let rules = [{
    regFun () {
      return val.replace(/\s+/, '').length >= 8
    },
    msg: $bp_t('在8位以上', 'bp.util_tool_above_eight_digit')
  },
  {
    reg: new RegExp('[A-Z]'),
    msg: $bp_t('包含大写字母', 'bp.util_tool_include_capital_letters')
  },
  {
    reg: new RegExp('[a-z]'),
    msg: $bp_t('包含小写字母', 'bp.util_tool_include_lowercase_letters')
  },
  {
    reg: new RegExp('[0-9]'),
    msg: $bp_t('包含数字', 'bp.util_tool_include_digit')
  },
  {
    reg: new RegExp('[!%&@#\\$\\^\\*\\?_~`\\.\\/\\+={}:"\\(\\);,\\-\'<>\\[\\|\\]]'),
    msg: $bp_t('包含特殊字符', 'bp.util_tool_contains_special_characters')
  }
  ]
  let msg = ''
  if (rules.some(rule => {
    let macth = rule.regFun ? rule.regFun() : rule.reg.test(val)
    if (!macth) {
      msg = rule.msg
      return true
    }
  })) {
    return $bp_t('您的密码须', 'bp.util_tool_your_password_must_be') + '：' + msg
  }
  return msg
}

export const isOneOf = (value, validList) => {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

// https://lodash.com/docs/4.17.11#get
export {
  safetyGet
}
// 执行深比较来确定两者的值是否相等

export const getCascaderValue = (value, validList) => {
  let result = []
  let cascader1 = []
  let cascader2 = []
  if (!(validList && validList.length)) {
    return false
  }
  validList.forEach(function (item) {
    if (item.children) {
      cascader1 = where(item.children, {
        'value': value
      })
      if (cascader1.length) {
        result[0] = item.value
        result[1] = value
      } else {
        item.children.forEach(function (item2) {
          if (item2.children) {
            cascader2 = where(item2.children, {
              'value': value
            })
            if (cascader2.length) {
              result[0] = item.value
              result[1] = item2.value
              result[2] = value
            }
          }
        })
      }
    }
  })
  if (!result.length) return [value]
  return result
}

export const getCascaderText = (value, validList) => {
  let result = []
  let cascader1 = []
  let cascader2 = []
  if (!(validList && validList.length)) {
    return false
  }
  validList.forEach(function (item) {
    if (item.children) {
      cascader1 = where(item.children, {
        'value': value
      })
      if (cascader1.length) {
        result[0] = item.label
        result[1] = cascader1[0].label
      } else {
        item.children.forEach(function (item2) {
          if (item2.children) {
            cascader2 = where(item2.children, {
              'value': value
            })
            if (cascader2.length) {
              result[0] = item.label
              result[1] = item2.label
              result[2] = cascader2[0].label
            }
          }
        })
      }
    }
  })
  return result
}

/**
 * @param text 文字内容
 * @param fontStyle 被计算的文字的样式
 */
export const measureTextWidth = (text, styleObj) => {
  /*
   * font参数的值分为
   * font-style: normal(正常), italic(斜体字), oblique(倾斜字体)
   * font-variant: normal(正常), small-caps(英文小写字母变成小的大写)
   * font-weight: normal(正常), bold(加粗) 100-900(一般不用)
   * font-size: 文字大小
   * font-family: 字体样式
   */
  styleObj = styleObj || {}

  let fontStyle = styleObj.fontStyle || 'normal'
  let fontVariant = styleObj.fontVariant || 'normal'
  let fontWeight = styleObj.fontWeight || 'normal'
  let fontSize = styleObj.fontSize || '14px'
  let fontFamily = styleObj.fontFamily || 'PingFangSC-Regular, tahoma, arial, "Hiragino Sans GB", "Microsoft yahei", sans-serif'

  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  ctx.font = `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize} ${fontFamily}`
  let width = ctx.measureText(text).width
  ctx = null
  return width
}

// 千位分隔符
export const milliFormat = (num) => {
  return num && num.toString()
    .replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 检测是否包含emoji
export const emojiCheck = (str) => {
  return new RegExp(emojiRegex).test(str)
}

/**
 * 校验输入数字合法性
 * @param str 输入数字
 * @param decimal 小数位数（=0是为整数）默认 2
 * @returns {String} 返回报错文案
 */
export const validNumberString = (str, decimal = 2) => {
  let decimalReg = RegExp(`^-?([0-9])+(.[0-9]{1,${decimal || 1}})?$`)
  if (!str) {
    return ''
  } else if (isNaN(str)) {
    return $bp_t('仅支持输入数字', 'bp.util_tool_only_input_numbers')
  } else if (/^-?0([0-9])+(.[0-9]{1,2})?$/.test(str)) {
    return $bp_t('不能以0开头，请正确输入', 'bp.util_tool_cannot_start_with_zero')
  } else if (decimal === 0 && !/^-?\d+$/.test(str)) {
    return $bp_t('仅支持输入整数', 'bp.util_tool_only_integers_supported')
  } else if (decimal > 0 && !decimalReg.test(str)) {
    return $bp_t(`仅支持最多${decimal}位小数`, 'bp.util_tool_only_support_most_decimal', {
      data: decimal
    })
  }
  return ''
}

export const uniqueArr = (arr) => {
  const x = new Set(arr)
  return [...x]
}

// 寻找 vue 组件
export const findComponent = function (filter, cb) {
  this.$children.forEach(child => {
    if (filter(child)) {
      cb(child)
    } else {
      findComponent.apply(child, [filter, cb])
    }
  })
}

export const halfStrLen = (str) => {
  return StrLen(str) / 2
}

// 标题中双字节字符为1个字，单字节字符为0.5个字
export const calTitleLength = (value = '') => {
  let reg = new RegExp(Regs.strWithZhCn, 'g')
  return Math.ceil(value.replace(reg, '01').length / 2)
}

/**
 * 二级域名替换
 * 将当前域名的二级域名替换为targetName
 */
export const subDomainChange = (targetName) => {
  let hostArr = window.location.hostname.split('.')
  hostArr[0] = targetName
  return '//' + hostArr.join('.')
}
/**
 * 判断访问来源是否是pc
 * true则pc，false则mobile
 */
export const isPC = () => {
  let u = navigator.userAgent
  let Agents = ['Android', 'iPhone', 'webOS', 'BlackBerry', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = true
  for (let i = 0; i < Agents.length; i++) {
    if (u.indexOf(Agents[i]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

/**
 * 页面跳转，对要跳转的URL做合法性校验
 * @param url 要跳转的 url
 * @param options 可选，其他配置项 {target: '_self', checkWhiteHost: true}
 */
export const openUrl = function (url, options = {}) {
  options = Object.assign({
    checkWhiteHost: true,
    target: '_self'
  }, options)

  let urlParse = parseUrl(url)
  if (/^https?:/.test(urlParse.protocol)) {
    let {
      target,
      checkWhiteHost
    } = options
    if (checkWhiteHost) {
      let white = whiteHost.some(host => {
        // 拼接一个 . 为了兼容 toutiao.com 这类的主域名
        return urlParse.hostname && ('.' + urlParse.hostname).endsWith(host)
      })
      if (!white) {
        showHint($bp_t('跳转链接有误', 'bp.util_tool_wrong_jump_link'), 'error', 3000)
        return false
      }
    }
    var a = document.createElement('a')
    a.href = Urls.updateQueryWithAdvid(urlParse.href)
    a.target = target
    a.click()
  } else {
    showHint($bp_t('跳转链接有误', 'bp.util_tool_wrong_jump_link'), 'error', 3000)
  }
}

/**
 * 受众预估数字格式化成中文单位
 * 格式化规则详见：https://wiki.bytedance.net/pages/viewpage.action?pageId=346091913
 * @param num 要格式化的数
 */
export const formatEstimateNum = (num) => {
  if (!isNaN(Number(num))) {
    switch (true) {
      case num < 1e4:
        num = `<1${$bp_t('万', 'common.ten_thousand')}`
        break
      case num >= 1e4 && num < 1e5:
        num = `${rounding(num / 1e4, 1)}${$bp_t('万', 'common.ten_thousand')}`
        break
      case num >= 1e5 && num < 1e6:
        num = `${rounding(num / 1e4, 0)}${$bp_t('万', 'common.ten_thousand')}`
        break
      case num >= 1e6 && num < 1e7:
        num = `${rounding(num / 1e5, 0)}0${$bp_t('万', 'common.ten_thousand')}`
        break
      case num >= 1e7 && num < 1e8:
        num = `${rounding(num / 1e6, 0)}00${$bp_t('万', 'common.ten_thousand')}`
        break
      case num >= 1e8:
        num = `${rounding(num / 1e8, 1)}${$bp_t('亿', 'bp.util_tool_a_hundred_million')}`
        break
      default:
        break
    }
  }
  return num
}

/**
 * 判断是否支持某一个css属性
 * @param attr 属性
 * @param value 属性的值
 */
export const cssSupport = (attr, value) => {
  var element = document.createElement('div')
  if (attr in element.style) {
    element.style[attr] = value
    return element.style[attr] === value
  } else {
    return false
  }
}
// "main_brand":{
//   "8026":"OPPO"
// },
// "sub_brand":{
//   "8026":{
//       "451325":"OPPO K1"
//   }
// }

/**
 * 将上面的用一级数据表示的 tree 转换为一颗 符合 byted-cascader options 的 tree
 */
export const data2BytedCascaderOptions = (...levels) => {
  const mainLevel = levels[0]
  const data2Option = (obj) => {
    return Object.keys(obj).map(v => ({
      label: obj[v],
      value: v
    }))
  }
  const data2Array = (obj) => {
    return Object.keys(obj).map(v => ({
      key: v,
      child: data2Option(obj[v])
    }))
  }
  const result = data2Option(mainLevel)
  let curIndex = 0
  const perform = (parent, someLevel) => {
    if (!parent || curIndex >= someLevel.length) {
      return
    }
    for (let i = 0; i < parent.length; i++) {
      if (parent[i].value === someLevel[curIndex].key) {
        parent[i].children = someLevel[curIndex].child
        curIndex++
      } else {
        perform(parent[i].children, someLevel)
      }
    }
  }
  for (let i = 1; i < levels.length; i++) {
    curIndex = 0
    perform(result, data2Array(levels[i]))
  }
  return result
}

// 摊平数组
export const floorArr = (arr) => {
  let res = []
  if (arr.length <= 0) {
    return res
  }
  const isArr = (v) => v instanceof Array
  arr.forEach(v => {
    res = res.concat(
      isArr(v) ? floorArr(v) : v
    )
  })
  return res
}

export const dateDifference = (sDate1, sDate2) => { // sDate1和sDate2是2006-12-18格式
  var dateSpan
  var iDays
  sDate1 = Date.parse(sDate1)
  sDate2 = Date.parse(sDate2)
  dateSpan = sDate2 - sDate1
  dateSpan = Math.abs(dateSpan)
  iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
  return iDays
}

export const formatThousandsCommas = (num) => {
  num = String(num)
  const nums = num.split('.')
  if (nums.length) {
    nums[0] = nums[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return nums.join('.')
}

export const transformMetricsParams = (item) => {
  if (!!item && item.metrics) {
    Object.keys(item.metrics).forEach(val => {
      item[val] = item.metrics[val]
    })
  }
  return item
}
export const selectPath = (path) => {
  if (path === 'reports_search_words') {
    return 'reports_query'
  } else if (path === 'reports_creative_procedural') {
    return 'reports_procreative'
  } else if (path === 'bp_reports_advertiser') {
    return 'bp_reports_account'
  } else {
    return path
  }
}
export const parseIntSafe = (num, def = 0, cb = parsed => parsed) => {
  const parsed = parseInt(num)
  return isNaN(parsed) ? def : cb(parsed)
}

export const isBp = () => {
  // isBp函数兼容boe中的bp域名
  return window.location.origin.includes('business')
}
// 试玩素材
export const isPlayableMaterial = () => {
  return window.location.pathname.includes('playable_material') && !showNavigator()
}

export const isPercentage = percentStr => /(\d|,)+(\.\d\d)?%$/.test(percentStr)

/**
 * 定时去除 hot icon
 * @param {Date} now 现在时间
 * @param {number} days 保留天数
 * @param {string} date 上线日期: yyyy-mm-dd
 */
export const isNowDaysAfterDate = (now, days, date) => {
  const offset = dayjs(now).diff(date, 'day')
  if (offset > 0 && Math.abs(offset) > days) {
    return true
  }
  return false
}

// 是否为BOE环境
export const isBoe = () => {
  const origins = window.location.host.split('.')
  const secondOrigin = origins[0]
  return /^.*-boe$/.test(secondOrigin)
}

// 获取BP Host
export const getBusinessHost = () => {
  const onlineHost = 'https://business.oceanengine.com'
  if (isBoe()) {
    return onlineHost
      .replace('https', 'http')
      .replace('business', 'business-boe')
  }
  return onlineHost
}

// 判断是否是ad2.0
export const isAdV2 = () => {
  const userVersion = window.localStorage.getItem('version')
  try {
    const aadvId = window.GLOBAL_VAR.advertiser.id
    if (aadvId) {
      const version = JSON.parse(userVersion)[aadvId] || 1
      return version === 2
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}

// 判断是账户密码登陆，不是附身登陆就是账户密码登陆
export const loginByPassword = () => {
  // staff附身，内部附身
  // coreUser附身，外部附身
  return !(window.GLOBAL_VAR?.sales !== 'false' || window.GLOBAL_VAR?.user_jobbed !== 'false')
}
/**
 * @desc 以下页面并且hide_main_nav=1的为嵌入页面，不显示header和leftMenu
 * @returns {boolean}
 */
export const showNavigator = () => {
  const query = queryToJson()
  const whiteList = new Set([
    '/pages/toolbox/material_library.html',
    '/pages/toolbox/playable_material/index.html',
    '/pages/toolbox/playable_material/create.html'
  ])
  return !(whiteList.has(window.location.pathname) && query['hide_main_nav'] === '1')
}
export const getCSRFToken = () => {
  return $.cookie('csrftoken')
}
// 处理上传图片接口更换/nbs/api/ads/creative/material/picture/upload带来的数据差异
export const transformUploadImgResp = (_result, file, isAdLab = false) => {
  const result = {
    'data': {},
    'code': _result.code,
    'extra': _result.extra,
    'msg': _result.msg
  }
  if (_result.code !== 0) {
    return result
  }
  try {
    if (isAdLab) {
      result.data = {
        'images': [
          {
            'exist': false,
            'image_info': {
              'file_name': file.name,
              'height': _result.data.height,
              'ratio': 1,
              'web_uri': _result.data.web_uri,
              'width': _result.data.width
            },
            'sign_url': _result.data.sign_url,
            'uri': [_result.data.web_uri],
            'url': _result.data.web_uri,
            'image_mode': '3'
          },
          {
            'exist': false,
            'image_info': {
              'file_name': file.name,
              'height': _result.data.width,
              'ratio': 1,
              'web_uri': _result.data.web_uri,
              'width': _result.data.height
            },
            'sign_url': _result.data.sign_url,
            'uri': [_result.data.web_uri],
            'url': _result.data.web_uri,
            'image_mode': '16'
          }
        ],
        'only_upload': false
      }
    } else {
      result.data = {
        'exist': false,
        'image_info': {
          'file_name': file.name,
          'height': _result.data.height,
          'ratio': 1,
          'web_uri': _result.data.web_uri,
          'width': _result.data.width
        },
        'sign_url': _result.data.sign_url,
        'uri': [_result.data.web_uri],
        'url': _result.data.web_uri
      }
    }
  } catch (e) {}
  return result
}
// 处理剪切图片接口更换/nbs/api/ads/creative/material/picture/crop带来的数据差异
export const transformCropImgResp = (_result, temp) => {
  const result = {
    'data': {},
    'code': _result.code,
    'extra': _result.extra,
    'msg': _result.msg
  }
  if (_result.code !== 0) {
    return result
  }
  try {
    result.data = {
      'exist': false,
      'image_info': {
        'file_name': temp.id,
        'height': _result.data.height,
        'ratio': 1,
        'web_uri': _result.data.web_uri,
        'width': _result.data.width
      },
      'sign_url': _result.data.sign_url,
      'uri': [_result.data.web_uri],
      'url': _result.data.web_url
    }
  } catch (e) {}
  return result
}

// 拼接数据
export const transformJssDKData = (info) => {
  return {
    ...info,
    video: {
      bitrate: info?.uploadResult?.VideoMeta?.Bitrate,
      duration: info?.uploadResult?.VideoMeta?.Duration,
      fileType: info?.uploadResult?.VideoMeta?.FileType,
      format: info?.uploadResult?.VideoMeta?.Format,
      height: info?.uploadResult?.VideoMeta?.Height,
      md5: info?.uploadResult?.VideoMeta?.Md5,
      originHeight: info?.uploadResult?.VideoMeta?.OriginHeight,
      originWidth: info?.uploadResult?.VideoMeta?.OriginWidth,
      size: info?.uploadResult?.VideoMeta?.Size,
      uri: info?.uploadResult?.VideoMeta?.Uri,
      width: info?.uploadResult?.VideoMeta?.Width,
      codec: info?.uploadResult?.VideoMeta?.Codec
    },
    poster: {
      oid: info?.uploadResult?.PosterUri
    },
    vid: info?.uploadResult?.Vid,
    uploadID: info?.UploadHeader?.UploadID || 0,
    statusCode: info?.res?.status || 200
  }
}

export default {
  transformJssDKData,
  showHint,
  isAdV2,
  loginByPassword,
  jsonToQuery,
  queryToJson,
  getValFromArray,
  getStringLen,
  getStr,
  updateQueryNoRefresh,
  updateQueryRefresh,
  replaceQueryNoRefresh,
  repeat,
  secondToMinute,
  parseSecondToDate,
  dateFormat,
  getTotalDaysOfTimeRange,
  timestampConverter,
  getTodayTimestamp,
  formatBigNum,
  type,
  getKeyByValue,
  getObjectKeyByValue,
  log,
  error,
  secHtmlNew,
  secHtml,
  en,
  throttle,
  debounce,
  sessionStore,
  randomChar,
  trys,
  StrLen,
  validField,
  clearObj,
  clearArr,
  isSupported,
  isBpSupported,
  parseUrl,
  randArr,
  permutation,
  rounding,
  getContinuousChildArr,
  getClockString,
  checkPwd,
  isOneOf,
  safetyGet,
  getCascaderValue,
  getCascaderText,
  measureTextWidth,
  milliFormat,
  emojiCheck,
  validNumberString,
  uniqueArr,
  findComponent,
  halfStrLen,
  calTitleLength,
  subDomainChange,
  isPC,
  openUrl,
  formatEstimateNum,
  cssSupport,
  data2BytedCascaderOptions,
  floorArr,
  dateDifference,
  formatThousandsCommas,
  transformMetricsParams,
  parseIntSafe,
  isBp,
  isPercentage,
  isNowDaysAfterDate,
  isBoe,
  getBusinessHost,
  showNavigator
}
